<template>
  <AppShell>
    <NavCardList :cards="cards" list-class="indexpage-list" style="margin-top: 0" />
  </AppShell>
</template>

<script setup>
import { onMounted } from 'vue';
import AppShell from '../components/AppShell.vue';
import NavCardList from '../components/NavCardList.vue';
import ConfirmDialog from '../components/ConfirmDialog.vue';
import { getLevelHomeCards } from '../composables/useNavCards.js';
import { useLevelHome } from '../composables/useLevelHome.js';
import { setLanguage } from '../scripts/boot.js';

const cards = getLevelHomeCards();

const {
  dialogVisible,
  dialogMessage,
  dialogShowActions,
  openClearDialog,
  onConfirm,
  onCancel,
  onClose,
} = useLevelHome();

onMounted(() => {
  window.setLanguage = setLanguage;
});
</script>
